import React from "react"
import { Box, useTheme, SxProps } from "@mui/material"
import { deepmerge } from "@mui/utils"

import { useTranslation } from "providers/i18n"

import { SearchToggleButton } from "components/domains/search/SearchToggleButton"
import { SearchIcon as DefaultSearchIcon } from "components/icons"

import { useAppUI } from "providers/ui"
import { LanguageButton } from "components/Language"
import { Image } from "components/Image"
import { LanguageSelectMenu } from "components/Language/LanguageSelectMenu"

export interface ISidebarMenuProps {
  sx?: SxProps
  AppNavigation?: React.ComponentType
}

export const SidebarMenu: React.FC<ISidebarMenuProps> = ({
  sx = {},
  AppNavigation,
}) => {
  const { openSearch } = useAppUI()
  const { t } = useTranslation()
  const theme = useTheme()

  const {
    root,
    navigationContainer,
    toolbarContainer,
    searchButton,
    languageSelectMenu,
    languageButton,
    headerContainer,
    headerLogo,
  } = theme.components[`SidebarMenu`]?.styleOverrides || {}

  const logoSrc = theme.assets?.logo?.url

  return (
    <Box sx={deepmerge(root, sx)}>
      {/* Header */}
      {logoSrc && (
        <Box sx={headerContainer}>
          <Box sx={headerLogo}>{<Image src={logoSrc} />}</Box>
        </Box>
      )}
      {/* Navigation */}
      <Box sx={navigationContainer}>{AppNavigation && <AppNavigation />}</Box>
      {/* Toolbar */}
      <Box sx={toolbarContainer}>
        <SearchToggleButton
          icon={DefaultSearchIcon}
          sx={searchButton}
          placeholder={t("Search...")}
          onClick={openSearch}
        />
        <LanguageSelectMenu sx={languageSelectMenu} />
        <LanguageButton sx={languageButton} />
      </Box>
    </Box>
  )
}
